// extracted by mini-css-extract-plugin
export default {"MONTH":"FGCfjZ","month":"FGCfjZ","DAY":"yZ63nM","day":"yZ63nM","YEAR":"ycGVpt","year":"ycGVpt","fields":"CSSG5t","mobile":"rtvGca"};